import {
    LOGIN, LOGOUT,
    FORGOT_PASSWORD, FORGOT_PASSWORD_VALIDATE_TOKEN, FORGOT_PASSWORD_CHANGE,
    USER_ACTIVATION, SEND_WELCOME_EMAIL,
    CHANGE_PASSWORD,
    CREATE_USER, UPDATE_USER, CHANGE_USER_PASSWORD, UPDATE_USER_STATUS, DELETE_USER,
    CREATE_CLIENT, UPDATE_CLIENT, UPDATE_CLIENT_STATUS, DELETE_CLIENT,
    FETCH_INVOICES, DOWNLOAD_INVOICE,
    FETCH_DELIVERY_NOTES, DOWNLOAD_DELIVERY_NOTE, DOWNLOAD_PACKING_LIST,
    DOWNLOAD_STOCK,
    FETCH_TECHNICAL_SHEETS, DOWNLOAD_TECHNICAL_SHEET
} from "../../../audit/audit-lib";

export default {
    "title": "Panel de Administración Extranet / Auditoría",
    "description": "Listado de eventos registrados",
    "filters": {
        "event": "Evento",
        "user": "Usuario",
        "client": "Cliente"
    },
    "auditTableHeader": "Total eventos: <0>{{count}}</0>",
    "auditTableColumns": {
        "event": "Evento",
        "user": "Usuario",
        "client": "Cliente",
        "date": "Fecha evento",
        "details": "Detalles evento"
    },
    "nameCollection": "eventos",
    "eventOptions": {
        LOGIN: "Iniciar sesión",
        LOGOUT: "Cerrar sesión",
        FORGOT_PASSWORD: "Contraseña olvidada",
        FORGOT_PASSWORD_VALIDATE_TOKEN: "Validar token para contraseña olvidada",
        FORGOT_PASSWORD_CHANGE: "Cambiar contraseña olvidada",
        USER_ACTIVATION: "Activación de usuario",
        SEND_WELCOME_EMAIL: "Enviar email de bienvenida",
        CHANGE_PASSWORD: "Cambiar contraseña",
        CREATE_USER: "Crear usuario",
        UPDATE_USER: "Actualizar usuario",
        CHANGE_USER_PASSWORD: "Cambiar contraseña a un usuario",
        UPDATE_USER_STATUS: "Actualizar estado a un usuario",
        DELETE_USER: "Eliminar usuario",
        CREATE_CLIENT: "Crear cliente",
        UPDATE_CLIENT: "Actualizar cliente",
        UPDATE_CLIENT_STATUS: "Actualizar estado a un cliente",
        DELETE_CLIENT: "Eliminar cliente",
        FETCH_INVOICES: "Consultar facturas",
        DOWNLOAD_INVOICE: "Descargar factura",
        FETCH_DELIVERY_NOTES: "Consultar albaranes",
        DOWNLOAD_DELIVERY_NOTE: "Descargar albarán",
        DOWNLOAD_PACKING_LIST: "Descargar packing list",
        DOWNLOAD_STOCK: "Descargar existencias",
        stocks_service: "Servicios de stock",
        FETCH_TECHNICAL_SHEETS: "Consultar fichas técnicas",
        DOWNLOAD_TECHNICAL_SHEET: "Descargar ficha técnica"
    }
}